import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import {
	Container
} from 'react-bootstrap'

// Layout
import RouteTemplate from './RouteTemplate'

const App = () => {
	return (
		<BrowserRouter>
			<Container fluid>
				<RouteTemplate />
			</Container>
		</BrowserRouter>
	)
}

export default App